module.exports = __webpack_public_path__ + "static/media/campus.4a7ccd38.png";